<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}VehicleParameter`"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <div [onyxAutoFocus]="data.mode">
    <app-dictionaries-names-translation-form
      [form]="form.controls.names"
      label="labels.parameterName"
      [initialValue]="data.mode === OnyxFormMode.ADD ? data.name : undefined"
    ></app-dictionaries-names-translation-form>
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'saveChanges'}`
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
